import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { DOCUMENTS_API } from "./apiRoutes";

interface mutateProps {
  parkDocId: string;
  communityId: string;
  data: FieldValues;
}

const mutateEscalateApprovalDoc = async ({
  parkDocId,
  communityId,
  data,
}: mutateProps) => {
  return await axiosAuth.post(`${DOCUMENTS_API(communityId)}/${parkDocId}/escalate-approval`, data);
};

const useEscalateApprovalDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateEscalateApprovalDoc,
    ...queryParams,
  });

export default useEscalateApprovalDocMutation;
